import { createTheme } from "@mui/material/styles";

export const lightTheme = createTheme({
  palette: {
    primary: {
      main: "#00a0d1",
    },
  },
  zIndex: {
    modal: 1250,
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: "#EDEDED",
        },
      },
    },
    MuiTooltip: {
      styleOverrides: {
        arrow: {
          color: "white",
        },
        tooltip: {
          boxShadow:
            "0px 2px 1px -1px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 1px 3px 0px rgba(0,0,0,0.12) !important",
          fontSize: 14,
          backgroundColor: "white",
          color: "#171B1F",
          maxHeight: "20vh",
          overflowY: "auto",
          minWidth: 160,
        },
        popper: {
          zIndex: 2001,
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        asterisk: {
          color: "red",
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          fontSize: "inherit",
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        body1: {
          fontSize: "inherit",
        },
      },
    },
    // Uncomment if needed
    // MuiButton: {
    //   styleOverrides: {
    //     root: {
    //       "&&:disabled": {
    //         boxShadow:
    //           "0px 1px 5px 0px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 3px 1px -2px rgba(0,0,0,0.12)",
    //       },
    //     },
    //   },
    // },
    MuiButtonBase: {
      styleOverrides: {
        root: {
          "&.Mui-disabled": {
            pointerEvents: "auto",
          },
        },
      },
    },
    // ExpansionPanel → Accordion in MUI v5
    // MuiAccordion: {
    //   styleOverrides: {
    //     root: {
    //       "&::before": {
    //         display: "none",
    //       },
    //     },
    //   },
    // },
    MuiFormHelperText: {
      styleOverrides: {
        contained: {
          marginLeft: 0,
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        label: {
          whiteSpace: "pre",
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        head: {
          backgroundColor: "#EDEDED",
          color: "#545454",
          fontSize: 14,
          fontWeight: 700,
        },
        body: {
          color: "#545454",
          fontSize: 14,
          fontWeight: 700,
        },
        root: {
          padding: 8,
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        elevation1: {
          boxShadow: "0px 2px 4px rgb(0 0 0 / 10%)",
        },
      },
    },
  },
});
